class FilePresenter {
  // updateEachByIdAndRecache
  // Matches two arrays of FilePresenters by id and mutates each
  //  - `cachedFPList` will each call `update()` with the matching target FP
  //  - `targetFPList` will each be _replaced_ with the matching cached FP after the cached FP has been updated
  static updateEachByIdAndRecache(targetFPList = [], cachedFPList = []) {
    if (!cachedFPList.length) return;
    targetFPList.forEach((targetFPInstance) => {
      const cachedFPInstance = cachedFPList.find(
        (_cached) => _cached.id() === targetFPInstance.id()
      );
      cachedFPInstance.update(targetFPInstance);
      Object.assign(targetFPInstance, cachedFPInstance);
    });
  }

  static errorsFrom(instances = []) {
    return instances.map((_fp) => _fp.error()).filter(Boolean);
  }

  constructor(data = {}) {
    this.update(data);
  }

  update({
    uploadAt,
    reason,
    isSuccessful,
    uppyFile: newUppyFile = {},
    meta: newMeta = {},
  }) {
    this.uploadAt = uploadAt || this.uploadAt;
    this.reason = reason || this.reason;
    this.isSuccessful = isSuccessful ?? this.isSuccessful; // null-coalescing because value type is boolean
    this.uppyFile = { ...this.uppyFile || {}, ...newUppyFile };
    this.meta = { ...this.meta || {}, ...newMeta };
    return this;
  }

  id() {
    return this.uppyFile.id ?? null;
  }

  url() {
    return this.uppyFile.uploadURL ?? null;
  }

  error() {
    return this.uppyFile.error ?? null;
  }

  serialize() {
    return {
      error: this.error(),

      // `meta` data
      bucket: this.meta.ConfirmedBucket ?? null,
      key: this.meta.ConfirmedKey ?? null,

      // shared `meta` & `uppyFile` data
      mimetype: (this.meta.filetype || this.uppyFile.type) ?? null,

      // `uppyFile` data
      extension: this.uppyFile.extension ?? null,
      filename: this.uppyFile.displayName ?? null,
      size: this.uppyFile.size ?? null,
      source: this.uppyFile.source ?? null,
      uploadUrl: this.uppyFile.uploadURL ?? null,

      reason: this.reason ?? null,
      isSuccessful: this.isSuccessful ?? null,
      isFailed: (this.isSuccessful === false || this.error()) ? true : null,
      uploadAt: this.uploadAt?.toUTCString() ?? null,
      uploadAtTimeElapsed: this.#timeElapsedSince(this.uploadAt),
    };
  }

  #timeElapsedSince(date) {
    if (!(date instanceof Date)) return null;
    return new Date().getTime() - date.getTime();
  }
}

export default FilePresenter;
